import { useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getTriviaCost,
  getTriviaLeaderboard,
  getTriviaStats,
} from '@wwe-portal/web/services/client/trivia-rumble';
import { useIsAuthenticated } from '../stores/auth-store';

const QUERY_KEY_PREFIX = 'trivia-rumble';

export const useTriviaRumbleStats = () => {
  const isAuthenticated = useIsAuthenticated();
  return useQuery({
    queryKey: [QUERY_KEY_PREFIX, 'stats'],
    queryFn: () => getTriviaStats(),
    enabled: isAuthenticated,
  });
};

export const useTriviaRumbleCost = () => {
  return useQuery({
    queryKey: [QUERY_KEY_PREFIX, 'cost'],
    queryFn: () => getTriviaCost(),
  });
};

export const useInvalidateTriviaLeaderboard = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: [QUERY_KEY_PREFIX, 'leaderboard'],
    });
};

export const useTriviaLeaderboard = () => {
  return useQuery({
    queryKey: [QUERY_KEY_PREFIX, 'leaderboard'],
    queryFn: () => getTriviaLeaderboard(),
  });
};
